import helperA11y           from 'shared/mixins/helper-a11y';
import helperUtilities      from 'shared/mixins/helper-utilities';

/**
 * @module
 *
 */

const selector = '[data-js-additional-content]';
const additionalContent = function(el, app) {

    const a11yHelper                = helperA11y(app);
    const content                   = el;
    const $content                  = $(content);      // the $ obj of primary content content container that will be toggled off and one
    const $buttons                  = $($content.attr('data-toggle-additional-content-button'));           // the $ obj of any buttons/inputs that will carry out the toggling

    const classContentStateVisible  = 'Ge-AdditionalContent--visible';
    const classContentStateHidden  = 'Ge-AdditionalContent--hidden';
    const classButtonStateUnToggled = 'Ge-Toggle-Btn--off';
    const classButtonStateToggled   = 'Ge-Toggle-Btn--on';

    /* classes */

    const init = function() {

        // don't init if inside a popup - it will be initialised when the popup is initialised
        if ($content.closest('[data-js-popup]').length) {
            return;
        }
        
        // initialise the buttons
        registerEvents();
        // start accepting clicks

    };

    // register events
    const registerEvents = function() {
        let action = 'click';
        $buttons.on('click', function(ev) {
            if( $content.hasClass( classContentStateVisible ) ){
                $content.removeClass(classContentStateVisible);
                $content.addClass(classContentStateHidden);
                $buttons.addClass(classButtonStateUnToggled).removeClass(classButtonStateToggled);
                a11yHelper.hide($content);
                $(this).prev()[0].scrollIntoView({ behavior: 'instant', block: 'nearest' });
            }
            else {
                $content.addClass(classContentStateVisible);
                $content.removeClass(classContentStateHidden);
                $buttons.addClass(classButtonStateToggled).removeClass(classButtonStateUnToggled);
                // enable all aria and hidden fields
                a11yHelper.show($content);
                // if we're keyboard navigating, focus on the first item in the content
                a11yHelper.reFocus(ev, $content.find('a,button,input,select').first());
                $(this).prev()[0].scrollIntoView({ behavior: 'instant', block: "nearest" });
            }
        });
    };



    // trigger the toggle transition


    return {
        init: init()
    };
};

additionalContent.selector = selector;

export default additionalContent;
